export const ENTERPRISE_LOCALE_NAME = 'Enterprise';
export const ENTERPRISE_LOCALE_NAME_2 = 'Enterprise';
